import { render, staticRenderFns } from "./AnswersWin.vue?vue&type=template&id=3656dfd9&"
import script from "./AnswersWin.vue?vue&type=script&lang=js&"
export * from "./AnswersWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports